import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { DxHtmlEditorComponent } from "devextreme-angular";

@Component({
    selector: "app-html-editor",
    templateUrl: "./html-editor.component.html",
    styleUrls: ["./html-editor.component.css"]
})
export class HtmlEditorComponent {
    @Input() value: string;
    @Input() placeholder: string;
    @Input() readOnly = true;
    @Input() height = "410";
    @Input() maxHeight = "20";
    @Output() valueChange = new EventEmitter<string>();
    @ViewChild(DxHtmlEditorComponent, { static: false }) htmlEditor: DxHtmlEditorComponent;
}
